const thrpiesAdmissionStatuses = {
  Unset: -1,
  NoVinculado: 1,
  ServicioRelacionadoActivo: 4,
  NoVigenteAlta: 5,
  NoVigenteBajas: 6,
  Alertas: 9,
  Admitido: 11,
  Vinculado: 12,
  Asignado: 13,
  NoVigenteFinAnioEscolar: 14,
  NoVigenteTraslado: 18,
  ReferidoRechazado: 22,
  ReferidoAlDirectorCSEE: 23,
  AprobadoEnRemedioProvisional: 24,
  NoVinculadoDenegadoRemPro: 29,
  NoVigenteEgreso: 30,
  NoVigenteCambioDeServicio: 25,
  NoVinculadoTrasnferidoSAE: 31,
  DevueltoEscuela: 32,
};

export default thrpiesAdmissionStatuses;
